import React, { useContext, useState } from "react";
import { Calendar, Badge, Typography, Row, Flex, Space } from "antd";
import "./timeslots.css";
import SelectLocation from "./SelectLocation/SelectLocation";
import dayjs from "dayjs";
import BookSlot from "./BookSlot/BookSlot";
import { AuthContext } from "$context/AuthContextProvider";
import { Navigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchTimeSlotsQuery } from "$api/client";
import UpdateBooking from "./UpdateBooking";
import ImportFile from "./ImportTimeSlots";
import DeliveryTimeField from "../CarLocationComponent/DeliveryTimeField";
import { Col } from "antd/lib";
const { Text } = Typography;

const TimeSlots = () => {
  const [selectedLocation, setSelectedLocation] = useState({
    locationId: null,
    dealerCode: "",
    deliveryTime: null,
  });
  const authContext = useContext(AuthContext);

  const { data: locationTimeSlots } = useQuery({
    queryKey: ["timeSlots", selectedLocation.locationId],
    queryFn: fetchTimeSlotsQuery,
    enabled: selectedLocation.locationId !== null,
  });

  const dataCellRender = (current) => {
    if (locationTimeSlots) {
      const date_str = current.format("YYYY-MM-DD");
      let item = locationTimeSlots[date_str];
      if (item) {
        item = item.sort((a, b) => dayjs(a.date) - dayjs(b.date));
        const items = item.map((value, index) => {
          if (value.booked === false) {
            let badge = <Badge status="success" />;
            let button = (
              <BookSlot
                key={selectedLocation}
                locationId={selectedLocation.locationId}
                timeSlots={locationTimeSlots}
                locationSlot={value}
              />
            );

            return (
              <div key={value.id}>
                <Text level={5} style={{ marginBottom: "-25px" }}>
                  {badge} {button}
                </Text>
              </div>
            );
          } else {
            let badge = <Badge status="error" />;
            let button = (
              <UpdateBooking
                key={selectedLocation}
                timeSlots={locationTimeSlots}
                locationSlot={value}
              />
            );
            return (
              <div key={value.id}>
                <Text level={5} style={{ marginBottom: "-25px" }}>
                  {badge} {button}
                </Text>
              </div>
            );
          }
        });

        return <>{items}</>;
      }
      return null;
    }
  };
  if (authContext.isAuthenticated === false || authContext.isAdmin === false) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="layout-card">
      <div className="slot_card">
        <Row>
          <Col span={8}>
            <Space align="vertical">
              <SelectLocation
                selectedItem={selectedLocation}
                handleChange={setSelectedLocation}
              />
              {selectedLocation.dealerCode !== "" && authContext.isAdmin && (
                <DeliveryTimeField
                  selectedLocation={selectedLocation}
                  handleChange={setSelectedLocation}
                />
              )}
            </Space>
          </Col>
          <Col span={8} offset={8} style={{ paddingBottom: "10px" }}>
            <Flex align={"flex-end"} justify="flex-end" gap="middle">
              <BookSlot
                key={selectedLocation}
                locationId={selectedLocation.locationId}
                timeSlots={locationTimeSlots}
              />

              <ImportFile
                url={"/slots/import_excel"}
                text={"Zeitslots Importieren"}
              />

              <ImportFile
                url={"/bookings/import"}
                text={"Termine Importieren"}
              />
            </Flex>
          </Col>
        </Row>
        <div className="calendar_card">
          <Calendar
            key={selectedLocation}
            cellRender={dataCellRender}
            style={{ height: "auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default TimeSlots;
